<!--
 * @Author: yaoyuting
 * @Date: 2019-08-28 23:45:02
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-04-09 11:22:38
 * @Descripttion:
-->
<template>
  <div class="home">
    <!-- <div class="header">
      <Header></Header>
    </div> -->
    <div class="main">
      <Main ref="main"></Main>
    </div>
    <div class="footer">
      <Footer v-if="$route.meta.alive"></Footer>
    </div>
  </div>
</template>

<script>
// import Header from '@/components/m/Header.vue';
import Main from '@/components/m/Main.vue';
import Footer from '@/components/m/Footer.vue';

export default {
  name: 'Home',
  mounted() {
    // window.addEventListener('scroll', this.handleScroll, true);
    // 监听（绑定）滚轮 滚动事件
  },
  watch: {},
  data() {
    return {
      header: false,
    };
  },
  methods: {
    handleScroll() {
      // 页面滚动距顶部距离
      const scrollTop = window.pageYOffset
        || document.documentElement.scrollTop
        || document.body.scrollTop;
      if (scrollTop > 30) {
        this.header = true;
      } else {
        this.header = false;
      }
    },
  },
  components: {
   
    Main,
    Footer,
  },
};
</script>

<style lang="less">
.el-message {
  position: fixed;
  top: 120px !important; /* 距离顶部20px，避免被遮挡 */
  left: 50%;
  transform: translateX(-50%);
  z-index: 999999999 !important;
  max-width: 90%; /* 最大宽度，避免在移动端超出视口 */
  box-sizing: border-box;
}

  .fix {
    position: fixed !important;
    top: 0 !important;

    left: 0 !important;
    // background: red !important;
  }
  .home {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    background: #000;
  }
  Header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 999;
  }
  .header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 999;
  }
  .bg {
    background: #231f38;
  }
  .Main {
    width: 100%;
  }
  .Footer {
    width: 100%;
    display: flex;
    justify-content: center;
    background-color: #01192e;
  }
</style>
